// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"44":"/1.8.0/js/vendor","431":"/1.8.0/js/app","496":"1.8.0/css/app"}[chunkId] + ".css";
};